import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { adminApi } from "../../lib/api";

export const SubscribersTab = () => {
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    adminApi.get("/admin/subscribers").then((r) => setSubs(Array.isArray(r.data) ? r.data : [])).catch(() => setSubs([]));
  }, []);

  const exportCsv = () => {
    const csv = ["email,signed_up", ...subs.map((s) => `${s.email},${s.created_at}`)].join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "subscribers.csv";
    a.click();
  };

  return (
    <div>
      <div className="mb-5 flex items-center justify-between">
        <p className="font-mono text-xs uppercase tracking-widest text-zinc-400" data-testid="subscribers-count">{subs.length} subscribers</p>
        <button data-testid="subscribers-export-btn" onClick={exportCsv} disabled={!subs.length} className="btn-ghost"><Download size={15} /> Export CSV</button>
      </div>
      <ul className="divide-y divide-white/10 rounded-2xl border border-white/10 bg-[#12141C]">
        {subs.map((s) => (
          <li key={s.email} className="flex flex-col justify-between gap-1 p-4 sm:flex-row" data-testid="subscriber-row">
            <span className="break-all text-white">{s.email}</span>
            <span className="text-sm text-zinc-400">{new Date(s.created_at).toLocaleString("en-CA")}</span>
          </li>
        ))}
        {!subs.length && <li className="p-8 text-center text-zinc-400">No subscribers yet.</li>}
      </ul>
    </div>
  );
};
